module.exports = {
  extractRgb(color) {
    let localColor = color;
    let result;
    localColor = localColor.trim();
    if (localColor.substring(0, 3) === 'rgb') {
      result = localColor
        .replace(/^(rgb|rgba)\(/, '')
        .replace(/\s/g, '')
        .replace(/\)$/, '')
        .split(',');
      result = result
        ? {
            r: parseInt(result[0], 16),
            g: parseInt(result[1], 16),
            b: parseInt(result[2], 16),
          }
        : null;
    } else {
      result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(localColor);
      result = result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null;
    }
    return result;
  },

  isDark(color) {
    let luma = false;
    let isDark = true;

    if (typeof color !== 'undefined' && color !== '') {
      // console.log("color:" + color);
      const rgb = this.extractRgb(color);
      luma = 0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b; // per ITU-R BT.709
    } else {
      // console.log("color empty");
    }
    // console.log('luma', luma);
    if (luma > 150) {
      isDark = false;
    }
    return isDark;
  },
};
